import { appBrands, currentAppBrand } from '@b2ag/app-brands'

export const defaultImagePerProductKind = {
  sante_vegetal: new URL(`../assets/img/product/aladin/product_default_crop_protection.jpg`, import.meta.url).href,
  semences: new URL('../assets/img/product/aladin/product_default_seed.jpg', import.meta.url).href,
  nutrition_vegetal_amendements: new URL(
    `../assets/img/product/aladin/product_default_nutrition_amendments.jpg`,
    import.meta.url,
  ).href,
  services: new URL(`../assets/img/product/aladin/product_default_service.jpg`, import.meta.url).href,
  equipements_exploitant: new URL(`../assets/img/product/aladin/product_default_farmer_equipment.jpg`, import.meta.url)
    .href,
  equipements_culture: new URL(`../assets/img/product/aladin/product_default_culture_equipment.jpg`, import.meta.url)
    .href,
  equipement_vigne_arbo: new URL(`../assets/img/product/aladin/product_default_vine_equipement.jpg`, import.meta.url)
    .href,
  amenagement_exploitation: new URL(
    `../assets/img/product/aladin/product_default_farm_development.jpg`,
    import.meta.url,
  ).href,
}

export function getProductDefaultImageFull(kind: string, type?: string): string | undefined {
  switch (currentAppBrand) {
    case appBrands.Aladin:
    case appBrands.Farmi:
    case appBrands.Countrymalt:
      return type === 'Pack'
        ? new URL(`../assets/img/product/aladin/product_default_crop_protection_pack.jpg`, import.meta.url).href
        : defaultImagePerProductKind[kind]
    case appBrands.Episens:
      return new URL(`../assets/img/product/episens/product_default_episens.jpg`, import.meta.url).href
    default:
      return undefined
  }
}

export const defaultImagePerProductKind160Px = {
  sante_vegetal: new URL(`../assets/img/product/aladin/product_default_160_crop_protection.jpg`, import.meta.url).href,
  semences: new URL(`../assets/img/product/aladin/product_default_160_seed.jpg`, import.meta.url).href,
  nutrition_vegetal_amendements: new URL(
    `../assets/img/product/aladin/product_default_160_nutrition_amendments.jpg`,
    import.meta.url,
  ).href,
  services: new URL(`../assets/img/product/aladin/product_default_160_service.jpg`, import.meta.url).href,
  equipements_exploitant: new URL(
    `../assets/img/product/aladin/product_default_160_farmer_equipment.jpg`,
    import.meta.url,
  ).href,
  equipements_culture: new URL(
    `../assets/img/product/aladin/product_default_160_culture_equipment.jpg`,
    import.meta.url,
  ).href,
  equipement_vigne_arbo: new URL(
    `../assets/img/product/aladin/product_default_160_vine_equipement.jpg`,
    import.meta.url,
  ).href,
  amenagement_exploitation: new URL(
    `../assets/img/product/aladin/product_default_160_farm_development.jpg`,
    import.meta.url,
  ).href,
}

export function getProductDefaultImage160Px(kind: string, type?: string) {
  switch (currentAppBrand) {
    case appBrands.Aladin:
    case appBrands.Farmi:
    case appBrands.Countrymalt:
      return type === 'Pack'
        ? new URL(`../assets/img/product/aladin/product_default_160_crop_protection_pack.jpg`, import.meta.url).href
        : defaultImagePerProductKind160Px[kind]
    case appBrands.Episens:
      return new URL(`../assets/img/product/episens/product_default_160_episens.jpg`, import.meta.url).href
    default:
      return undefined
  }
}
const cloudinarySanteVegetalPack = 'products/default/product_default_crop_protection_pack'
export const cloudinaryDefaultImagePerProductKind = {
  sante_vegetal: 'products/default/product_default_crop_protection',
  semences: 'products/default/product_default_seed',
  nutrition_vegetal_amendements: 'products/default/product_default_nutrition_amendments',
  services: 'products/default/product_default_service',
  equipements_exploitant: 'products/default/product_default_farmer_equipment',
  equipements_culture: 'products/default/product_default_culture_equipment',
  equipement_vigne_arbo: 'products/default/product_default_vine_equipement',
  amenagement_exploitation: 'products/default/product_default_farm_development',
}

export function getCloudinaryProductDefaultImage(kind: string, type?: string) {
  switch (currentAppBrand) {
    case appBrands.Aladin:
    case appBrands.Farmi:
    case appBrands.Countrymalt:
      return type === 'Pack' ? cloudinarySanteVegetalPack : cloudinaryDefaultImagePerProductKind[kind]
    case appBrands.Episens:
      return 'products/default/product_default_episens'
    default:
      return undefined
  }
}
